// Hồi Sơn (UI_SPEC §16): bản kê của lần quyết toán khi vắng ≥ 1 canh giờ. Màn Hồi Sơn chỉ ĐỌC bản
// kê này (không tự tính). Bản gần nhất giữ lại để trang con Thân xem lại giữa phiên. Không lưu.
import { signal, computed } from '@preact/signals';
import type { IdleSettleReport } from '@sim/cultivation';

/** Lịch Luyện trong quãng vắng (Hồi Sơn khối "Xuất quan thu hoạch"). */
export interface TrialSummary {
  kills: number;
  items: number;
  equipped: number;
  salvaged: number;
  /** Trong số đã phân giải: vì túi đầy (DECISIONS M2). */
  salvagedFull: number;
  stones: number;
  /** Tiên+ vào Rương Chưa Mở. */
  sealed: number;
  goods: number;
}

export interface ReturnSummary {
  report: IdleSettleReport;
  /** Quãng vắng thật (ms), trước khi cắt trần. */
  absentMs: number;
  stepBefore: number;
  stepAfter: number;
  trial?: TrialSummary | null;
}

const _current = signal<ReturnSummary | null>(null);
const _last = signal<ReturnSummary | null>(null);

export const returnSummary = computed(() => _current.value);
export const lastReturnSummary = computed(() => _last.value);

export function showReturn(s: ReturnSummary): void {
  _current.value = s;
  _last.value = s;
}

/** Tu vi thật vào thanh = tổng hấp thụ − phần đọng thành Dư Khí − phần tràn mất ở viên mãn. */
export function qiIntoBar(r: IdleSettleReport): number {
  return Math.max(0, r.qiGained - r.overflowGained - r.wastedQi);
}

export function dismissReturn(): void {
  _current.value = null;
}
